// project imports
// action - state management
import * as actionTypes from "../../actions/actionTypes";
import { getUnitSymbolByUnit, itemType, unitType } from "./../types";
import { years } from "store/utils/years";
import {
  CUMULATIVE_SUBSCRIBERS_REDUCER_KEY,
  SUBSCRIPTION_REVENUE_REDUCER_KEY,
} from "..";
import { TOTAL_ANNUAL_SUBSCRIBERS_KEY } from "../subscriber-acquisitions/cumulativeSubscribersReducer";
import {
  annualAverageFeeMonths,
  numberOfNewSubscribersMonths,
  subscriptionRevenueMonths,
} from "./staticMonthsData";

// This is to filter based on company types
import { SaaSCoType, GeneralCoType } from "constants/companyTypes";

// subscriber acquisition assumption' keys
export const NUMBER_OF_NEW_SUBSCRIBERS_KEY = "numberOfNewSubscribers";
export const ANNUAL_AVERAGE_SUBSCRIPTION_FEE_KEY = "annualAverageFee";
export const SUBSCRIPTION_REVENUE_KEY = "subscriptionRevenue";

export const initialState = {
  [NUMBER_OF_NEW_SUBSCRIBERS_KEY]: {
    title: "Number of New Subscribers",
    unit: unitType.NUMBER,
    unitSymbol: getUnitSymbolByUnit(unitType.NUMBER),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.CALCULATION,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return getReducerFunc(CUMULATIVE_SUBSCRIBERS_REDUCER_KEY)[
        TOTAL_ANNUAL_SUBSCRIBERS_KEY
      ].calculate(yearKey, getReducerFunc, companyType);
    },
    months: numberOfNewSubscribersMonths,
    years: {
      [years.YEAR_1_KEY]: 5670,
      [years.YEAR_2_KEY]: 12389,
      [years.YEAR_3_KEY]: 18484,
      [years.YEAR_4_KEY]: 24456,
      [years.YEAR_5_KEY]: 31054,
    },
  },
  [ANNUAL_AVERAGE_SUBSCRIPTION_FEE_KEY]: {
    title: "Annual Average Subscription Fee",
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.INPUT,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return 0;
    },
    months: annualAverageFeeMonths,
    years: {
      [years.YEAR_1_KEY]: 49,
      [years.YEAR_2_KEY]: 49,
      [years.YEAR_3_KEY]: 49,
      [years.YEAR_4_KEY]: 49,
      [years.YEAR_5_KEY]: 49,
    },
  },
  [SUBSCRIPTION_REVENUE_KEY]: {
    title: "Subscription Revenue",
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.CALCULATION,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return (
        getReducerFunc(SUBSCRIPTION_REVENUE_REDUCER_KEY)[
          NUMBER_OF_NEW_SUBSCRIBERS_KEY
        ].calculate(yearKey, getReducerFunc, companyType) *
        getReducerFunc(SUBSCRIPTION_REVENUE_REDUCER_KEY)[
          ANNUAL_AVERAGE_SUBSCRIPTION_FEE_KEY
        ]["years"][yearKey]
      );
    },
    months: subscriptionRevenueMonths,
    years: {
      [years.YEAR_1_KEY]: 0,
      [years.YEAR_2_KEY]: 0,
      [years.YEAR_3_KEY]: 0,
      [years.YEAR_4_KEY]: 0,
      [years.YEAR_5_KEY]: 0,
    },
  },
};

// ==============================|| SUBSCRIPTION ACQUISITION ASSUMPTIONS REDUCER ||============================== //

const subscriptionRevenueReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_SUBSCRIPTION_REVENUE_BY_YEAR:
      return {
        ...state,
        [action.key]: {
          ...state[action.key],
          years: {
            ...state[action.key].years,
            [action.yearKey]: [action.amount],
          },
        },
      };
    case actionTypes.SET_SUBSCRIPTION_REVENUE_BY_MONTH:
      return {
        ...state,
        [action.key]: {
          ...state[action.key],
          months: {
            ...state[action.key].months,
            [action.yearKey]: [action.amount],
          },
        },
      };
    case actionTypes.REPLACE_SUBSCRIPTION_REVENUE_YEARS:
      return {
        ...state,
        [action.key]: {
          ...state[action.key],
          months: action?.payload,
        },
      };
    case actionTypes.RESET_SUBSCRIPTION_REVENUE_REDUCER:
      return initialState;
    default:
      return state;
  }
};

export default subscriptionRevenueReducer;
